  $(document).ready(function() {
    keyboard_accessibility();
  });

  // Keyboard accessibility
  function keyboard_accessibility() {
    $(document).keydown(function (e) {
      var code = e.keyCode ? e.keyCode : e.which;

      // ESC behaviors
      if (code == 27) {
      }

      // TAB behaviors
      if (!e.shiftKey && code == 9) {
        $('.social-share-menu-navigation li:last-child a').on({
          'blur': function() {
            $('.menu-main-toggle').focus();
            
          },
        });

        $('.menu-main-toggle.active').on({
          'blur': function() {
            $('.menu-item-language-switcher a').focus();
          },
        });

        if ( $('.menu-main-toggle').css('display') == 'flex' ) {
          $('#searchToggle-alt').on({
            'blur': function() {
              $('.search-block.active #searchToggle-alt').trigger('click');
            },
          });
        }
      }

      // SHIFT + TAB behaviors
      if (e.shiftKey && code == 9) {
        
      }

      // ENTER behaviors
      if (code == 13) {
        if ($('#searchToggle').is(':focus')) {
          setTimeout(function() {
            $('.search-block .search-field').focus();
          }, 300);
        }

        if ($('.menu-main-toggle:not(.active)').is(':focus')) {
          setTimeout(function() {
            $('.menu-item-language-switcher a').focus();
          }, 150);
        }

        // if ($('#searchToggle-alt').is(':focus')) {
        //   $('#searchToggle-alt').trigger('click');
        // }
      }
    });
  }